import Edit from './Edit';
import Media from './Media';
import Address from './Address';
import Password from './Password';
import Privacy from './Privacy';
import Email from './Email';
import Socials from './Socials';

const index = {
  Edit,
  Media,
  Address,
  Password,
  Privacy,
  Email,
  Socials,
};

export default index;